import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../_services';

@Component({ template: '' })
export class AuthLogoutComponent {

    constructor(private authenticationService: AuthenticationService, private router: Router) { 
        authenticationService.logout();
        this.router.navigate(['auth/login']);
    }
}